export function getdata() {
	let obj = {
			headData: [{
					title: "原字段名",
					prop: "test",
					width: "150"
				},
				// {
				// 	title: "是否起效",
				// 	prop: "tes2",
				// 	width: "200",
				// 	custom: true
				// },
				{
				title: "界面展示",
				prop: "specialIdentification",
				width: "350",
				custom: true
			},


		],
		headDataqz: [{
				title: "原字段名",
				prop: "tcode",
				width: "150"
			},
			// {
			// 	title: "是否起效",
			// 	prop: "tes2",
			// 	width: "200",
			// 	custom: true
			// },
			{
				title: "界面显示",
				prop: "tcoderef",
				width: "150",
				custom: true
			},
			{
				title: "是否写入余额表",
				prop: "tcodeWriteBalance",
				width: "200",
				custom: true
			},


		],

}
return obj
}
